import styled from 'styled-components';
import { colors } from '../colors';

interface collapseHeaderProps {
	margin?: string;
	padding?: string;
}

const CollapseHeader = styled.div<collapseHeaderProps>`
	display: flex;
	box-sizing: border-box;
	width: 100%;
	padding: 23px 25px;
	margin: ${(props) => props.margin};
	padding: ${(props) => props.padding};
	justify-content: space-between;
	h1 {
		font-size: 16px;
		line-height: 19px;
		color: ${colors.Grey58};
		font-family: 'RubikMedium' !important;
	}
	button {
		height: auto;
		padding: 0;
		background: transparent;
		min-height: auto;
	}
`;
export default CollapseHeader;
